/**
 * Paso0.js
 * Reconocimiento Facial
 * @author Jaiván Piña
 */

//Dependencies
import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import $ from 'jquery';
import { onBoardingDigital } from '../../actions/actions';
//material-ui
import Grid from '@material-ui/core/Grid';

// Components
import Vencimiento from './error/Vencimiento';
import { AvisoMobileRequerido } from './error/AvisoMobileRequerido';

//Assets
import listo from '../../static/img/listo.png';

//Services
import { processToken, storeToken } from './services/tokenService';
import { processClientData, processIdClientAnalytics } from './services/pixelService';
import { processFlow } from './services/flowService';

import { traerConfiguracionBackend } from '../PlazoFijo/Utils/BackendUnificado';
import { Layout } from './layout/Layout';

class Paso0 extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            paso: 0,
            puedeContinuar: false,
            primeraCarga: true,
            urlIndex: null,
            disabled : false
        }
        this.setPasoInicial = this.setPasoInicial.bind(this);
        this.validateFlow = this.validateFlow.bind(this);
        this.setSiguientePaso = this.setSiguientePaso.bind(this);
    }

  async  componentWillMount() {
        this.manejoDeLoading(true);
        localStorage.removeItem('url');
        await traerConfiguracionBackend(false, true) //TODO: mover a una subruta
        //first loading
        //tomo el token de la url la primera vez 
        const url = this.props.location.search.replace("?id=", "");
        storeToken(url); //meto el token en el store, sin saber si es valido o no.
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.token && this.state.primeraCarga) {
            this.validacionInicial();
        }
    }

    async validacionInicial() {
        this.setState({primeraCarga : false});
        try {
            //primero tiene que mandar el token para tener la sesion
            const urlIndex = await processToken(this.props.history);
            //despues tiene que mandar el persistClientData
            const clientData = await processClientData();
            processIdClientAnalytics('paso-0');
            this.setState({
                urlIndex,
                puedeContinuar : true
            }, () => {
                this.setPasoInicial();
                this.validateFlow();
            });
        }
        catch (error) {
            this.props.history.push("/error-resolucion");
        }
        finally {
            this.manejoDeLoading(false);
        }        
    }

    manejoDeLoading(predido) {
        if(predido) $(".load").fadeIn(700);
        else $(".load").fadeOut(700);
    }

    validateFlow() {
        processFlow(this.props.history, this.state.paso);
    }

    setPasoInicial() {
        this.props.dispatch(
            onBoardingDigital(0)
        );
    }

    setSiguientePaso() {
        this.setState({disabled : true})
        this.props.dispatch(
            onBoardingDigital(this.state.paso + 1)
        );
        this.props.history.push('/paso-1')
    }

    render() {
        if(this.state.puedeContinuar){
            if (isMobile) {
                if (this.props.valido) {
                    const footer = {
                        button: {
                            action : this.setSiguientePaso,
                            text : "continuar",
                            disabled : !this.props.valido || this.state.disabled
                        }
                    };
                    console.log("button ", footer);
                    const body = { img : { src : listo } }
                    return (
                        <Layout footer={footer} body={body}
                            tieneFooter>
                            <Grid container
                                direction="row"
                                justify="center"
                                alignItems="center">
                                <Grid item xs={12}>
                                    <div className="content-description">
                                        <h5 className="title" >¡Listo {this.props.nombre}! Ahora,</h5>
                                        <h5 className="title">validaremos tu identidad</h5>
                                        <h6 className="description">Tené tu DNI a mano y preparate para hacer algunos gestos frente a la cámara .</h6>
                                    </div>
                                </Grid>
                            </Grid>
                        </Layout>
                    );
                } else {
                    return <Vencimiento urlIndex={this.state.urlIndex} />
                }
            } else {
                return <AvisoMobileRequerido/>
            }
        } else {
            return null;
        }
    }
}

const mapStateToProps = function (state) {
    return {
        valido: state.token.valido,
        nombre: state.usuario.nombre,
        token: state.token.id
    }
}

export default connect(mapStateToProps)(Paso0);


// WEBPACK FOOTER //
// ./src/components/OnBoarding/Paso0.js